module.exports = __webpack_public_path__ + "img/avatar_default_7.f04f2ef2.svg";